// extracted by mini-css-extract-plugin
module.exports = {"modal_div":"ModalDellAdd_modal_div__88qsB","modal":"ModalDellAdd_modal__2yrwl"};